module.exports = ".p_text_align_center{\n text-align: center;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.css
// module id = ./src/app/login/login.component.css
// module chunks = main